import { z } from 'zod';

export const schemaResponse2FA = z.object({
    qr: z.string(),
    secret: z.string(),
});
export type SchemaResponse2FA = z.infer<typeof schemaResponse2FA>;
